<template >
    <div class="academic-analysis">
        <div class="page-banner" > 
            <div class="banner-search">
                <div class="search-tit "> 学术分析 </div>
                <div class="search-txt"> 本平台基于近二十年中医药高等院校、中医药学者发表的中医学学科的期刊、会议及学位论文....</div>
                <div class="search-cont"> 
                    <el-row  type="flex" class="row-bg" justify="space-between">
                        <el-col :span='4'>
                            <el-select  v-model="searchData.fieldName" placeholder="请选择">
                                <el-option
                                    v-for="item in searchInfoList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value" >
                                </el-option>
                            </el-select>
                        </el-col> 
                        <el-col  :span='16'> 
                            <el-input  placeholder="请输入内容"  v-model="searchData.keyword" ></el-input>
                        </el-col>
                        <el-col  :span='4' class="search-btn">
                            <div class="ai-btn" @click="getList(1)">
                                <span class="icon search-icon"></span>
                                <span class="search-txt" >搜索</span> 
                            </div>
                        </el-col>
                    </el-row>
                </div>  
            </div> 
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchInfoList:[
                {
                    value:'jg',
                    label:'机构分析',
                },
                {
                    value:'xk',
                    label:'学科分析',
                },
                {
                    value:'xz',
                    label:'学者分析',
                },
            ],
            searchData:{
                fieldName:'jg',
                keyword:'',
            },
        }
    },
    methods: {
        getList(num){
            console.log(num)
        }
    }
}
</script>
<style lang="less" scoped> 
@import url('./academicAnalysis/index.less');    
</style>